import Vue from "vue";
import Router from "vue-router";
import store from "@/stores/store";
import { token } from "@/services/token";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./views/Home.vue"),
    },
    // CRH - ORDER IN
    {
      path: "/crh/orderin",
      name: "crh_orderin",
      meta: {
        layout: "auth",
        guest: true,
      },
      component: () => import("./views/crh/OrderIn.vue"),
    },
    {
      path: "/search",
      name: "search",
      component: () => import("./views/Search.vue"),
    },
    // From Grab
    {
      path: "/fromgrab",
      name: "from_grab",
      component: () => import("./views/FromGrab.vue"),
    },
    {
      path: "/fromgrab2",
      name: "from_grab2",
      component: () => import("./views/FromGrab.vue"),
    },
    // AUTH
    {
      path: "/login",
      name: "login",
      meta: {
        layout: "auth",
        guest: true,
      },
      component: () => import("./views/auth/Login.vue"),
      beforeEnter: (to, from, next) => {
        const isWebView = navigator.userAgent.includes("wv");
        if (!isWebView) {
          next();
        } else {
          next({
            name: "home",
          });
        }
      },
    },
    {
      path: "/register",
      name: "register",
      meta: {
        layout: "auth",
        guest: true,
      },
      component: () => import("./views/auth/Register.vue"),
    },
    {
      path: "/password/reset",
      name: "forgot",
      meta: {
        layout: "auth",
        guest: true,
      },
      component: () => import("./views/auth/Forgot.vue"),
    },
    {
      path: "/password/reset/:token",
      name: "reset",
      meta: {
        layout: "auth",
        guest: true,
      },
      component: () => import("./views/auth/Forgot.vue"),
      props: (route) => ({
        query: route.query.email,
      }),
    },
    {
      path: "/verifikasi-data",
      name: "verifikasi data pks",
      meta: {
        auth: true,
        layout: "auth",
        // guest: true
      },
      component: () => import("./views/auth/VerifikasiData.vue"),
    },
    {
      path: "/validasi-otp",
      name: "validasi otp",
      meta: {
        layout: "auth",
        guest: true,
      },
      component: () => import("./views/OTPPage.vue"),
    },
    {
      path: "/sign-pks",
      name: "sign pks",
      meta: {
        layout: "auth",
      },
      component: () => import("./views/SignPKS.vue"),
    },
    {
      path: "/popup-axi",
      name: "popup axi",
      meta: {
        layout: "auth",
      },
      component: () => import("./views/PopupAXI.vue"),
    },
    {
      path: "/verifikasi-data/:id",
      name: "verifikasi data registrasi by id",
      props: true,
      meta: {
        layout: "auth",
        guest: true,
      },
      beforeEnter: (to, from, next) => {
        if (to.params.id.length >= 6) {
          next();
        } else {
          next({
            name: "home",
          });
        }
      },
      component: () => import("./views/axi/VerifikasiDataDetail.vue"),
    },
    {
      path: "/axi/register/mobile",
      name: "Registrasi AXI Mobile",
      meta: {
        layout: "auth",
        guest: true,
      },
      component: () => import("./views/axi/RegisterMobile.vue"),
    },
    {
      path: "/axi/register/mobile/:axi_id",
      name: "Registrasi AXI Mobile by AXI Id",
      props: true,
      meta: {
        layout: "auth",
        guest: true,
      },
      component: () => import("./views/axi/RegisterMobile.vue"),
    },
    // DICICIL AJA PROFILE
    {
      path: "/profile",
      name: "profile",
      component: () => import("./views/Profile.vue"),
    },
    // GUDANG INFO
    {
      path: "/gudang-info",
      name: "gudang_info",
      component: () => import("./views/GudangInfo.vue"),
    },
    {
      path: "/gudang-info/:slug",
      name: "gudang_info_detail",
      component: () => import("./views/GudangInfoDetail.vue"),
    },
    // POLICY
    {
      path: "/policy",
      name: "policy",
      component: () => import("./views/Privacy.vue"),
    },
    // MITRA MAXI
    {
      path: "/mitra-bisnis",
      name: "mitra_bisnis",
      component: () => import("./views/maxi/Partner.vue"),
    },
    {
      path: "/mitra-bisnis/register",
      name: "mitra_bisnis_register",
      component: () => import("./views/maxi/Register.vue"),
    },
    // MITRA MAXI
    {
      path: "/axi",
      name: "axi",
      component: () => import("./views/axi/AXI.vue"),
    },
    {
      path: "/axi/login",
      name: "axi_login",
      redirect: "/login",
      meta: {
        layout: "auth",
        guest: true,
      },
      component: () => import("./views/axi/Login.vue"),
    },
    // AXI AFTER LOGIN
    {
      path: "/axi/info",
      name: "axi_info",
      meta: {
        auth: true,
      },
      component: () => import("./views/axi/Info.vue"),
    },
    {
      path: "/axi/info-rekan-bisnis-:number/:mentor/:rb",
      name: "axi_info_rb",
      meta: {
        auth: true,
      },
      component: () => import("./views/axi/Info.vue"),
    },
    {
      path: "/axi/berita-terbaru",
      name: "axi_berita_terbaru",
      meta: {
        auth: true,
        layout: "auth",
      },
      component: () => import("./views/axi/News.vue"),
    },
    {
      path: "/axi/news",
      name: "axi_berita_terbaru_web",
      // meta: {
      //   auth: true,
      // },
      component: () => import("./views/axi/WebNews.vue"),
    },
    {
      path: "/axi/berita-terbaru/:slug",
      name: "axi_berita_terbaru_detail",
      meta: {
        auth: true,
        layout: "auth",
      },
      component: () => import("./views/axi/NewsDetail.vue"),
    },
    {
      path: "/axi/news/:slug",
      name: "axi_berita_terbaru_detail_web",
      // meta: {
      //   auth: true,
      // },
      component: () => import("./views/axi/WebNewsDetail.vue"),
    },
    {
      path: "/axi/download-materi",
      name: "axi_download_materi",
      meta: {
        auth: true,
        layout: "auth",
      },
      component: () => import("./views/axi/DownloadMaterial.vue"),
    },
    {
      path: "/axi/unduh-materi",
      name: "axi_unduh_materi",
      meta: {
        auth: true,
        // layout: "auth",
      },
      component: () => import("./views/axi/UnduhMateri.vue"),
    },
    {
      path: "/axi/unduh_report_ppd",
      name: "download_report_ppd",
      meta: {
        auth: true,
        // layout: "auth",
      },
      component: () => import("./views/axi/ReportPPD.vue"),
    },
    {
      path: "/axi/unduh-epks",
      name: "axi_unduh_epks",
      meta: {
        auth: true,
        // layout: "auth",
      },
      component: () => import("./views/axi/UnduhEpks.vue"),
    },
    {
      path: "/axi/testimonials",
      name: "axi_testimonial",
      meta: {
        auth: true,
      },
      component: () => import("./views/axi/Testimonial.vue"),
    },
    {
      path: "/axi/profile",
      name: "axi_profile",
      meta: {
        auth: true,
      },
      component: () => import("./views/axi/Profile.vue"),
    },
    {
      path: "/axi/update_axi",
      name: "update_axi",
      meta: {
        auth: true,
      },
      component: () => import("./views/axi/UpdateAXI.vue"),
    },
    {
      path: "/axi/sukses/verifikasi",
      name: "sukses_verifikasi",
      meta: {
        auth: true,
      },
      component: () => import("./views/axi/SuksesVerifikasi.vue"),
    },
    {
      path: "/axi/sukses/password",
      name: "sukses_password",
      meta: {
        layout: "guest2",
        guest: true,
      },
      component: () => import("./views/axi/SuksesSetPassword.vue"),
    },

    {
      path: "/axi/waiting_email_verification",
      name: "waiting_email_verification",
      meta: {
        auth: true,
      },
      component: () => import("./views/axi/WaitingVerifEmail.vue"),
    },
    {
      path: "/axi/change-password",
      name: "axi_change_password",
      meta: {
        auth: true,
      },
      component: () => import("./views/axi/ChangePassword.vue"),
    },
    {
      path: "/axi/set-password/:token",
      name: "axi_set_password",
      meta: {
        layout: "guest2",
        guest: true,
      },
      component: () => import("./views/axi/SetPassword.vue"),
      props: (route) => ({
        query: route.query.email,
      }),
    },

    {
      path: "/axi/register",
      name: "axi_register",
      component: () => import("./views/axi/Register.vue"),
      beforeEnter: (to, from, next) => {
        const isWebView = navigator.userAgent.includes("wv");
        if (!isWebView) {
          next();
        } else {
          next({
            name: "home",
          });
        }
      },
    },
    {
      path: "/axi/register/isCrh",
      name: "axi_register_byCrh",
      component: () => import("./views/axi/Register.vue"),
      // props: { name: "isCrh" }
    },
    {
      path: "/axi/register/:axi_id",
      name: "axi_register_byid",
      props: true,
      component: () => import("./views/axi/Register.vue"),
    },
    // SIMULASI
    {
      path: "/simulasi-cicilan/:extra?",
      name: "simulasi_cicilan",
      component: () => import("./views/SimulasiNew.vue"),
      //component: () => import("./views/Simulation.vue"),
      beforeEnter: (to, from, next) => {
        const isWebView = navigator.userAgent.includes("wv");
        if (!isWebView) {
          next();
        } else {
          next({
            name: "home",
          });
        }
      },
    },
    // STATUS PENGAJUAN
    {
      path: "/status-pengajuan",
      name: "status_pengajuan",
      component: () => import("./views/StatusPengajuan.vue"),
    },
    // KANTOR CABANG
    {
      path: "/kantor-cabang",
      name: "kantor_cabang",
      component: () => import("./views/KantorCabang.vue"),
    },
    {
      path: "/kantor-cabang/:cabang",
      name: "kantor_cabang_detail",
      component: () => import("./views/KantorCabangDetail.vue"),
    },
    // PRODUK PEMBIAYAAN
    {
      path: "/produk-pembiayaan/dana-tunai/faq",
      name: "product_faq",
      component: () => import("./views/product/Faq.vue"),
    },
    {
      path: "/produk-pembiayaan/dana-tunai/confirmation",
      name: "produk_data_tunai_confirmation",
      component: () => import("./views/product/ProductConfirmFilling.vue"),
    },
    {
      path: "/produk-pembiayaan/dana-tunai/confirmation/:refferal",
      name: "produk_data_tunai_confirmation_refferal",
      component: () => import("./views/product/ProductConfirmFilling.vue"),
      // beforeEnter: (to, from, next) => {
      //   if (from.path.includes('simulasi-cicilan/fromgrab')) {
      //     next()
      //   } else {
      //     next({
      //       name: 'home',
      //     })
      //   }
      // },
    },
    {
      path: "/produk-pembiayaan/:product",
      name: "product",
      component: () => import("./views/product/Product.vue"),
    },
    {
      path: "/produk-pembiayaan/:product/:name",
      name: "product_detail",
      component: () => import("./views/product/Detail.vue"),
    },
    {
      path: "/produk-pembiayaan/:product/:name/confirmation",
      name: "produk_data_tunai_confirmation_maxi",
      component: () => import("./views/product/ProductConfirmFilling.vue"),
    },
    {
      path: "/detail/:id/request",
      name: "detail_request",
      meta: {
        auth: true,
        layout: "auth",
      },
      component: () => import("./views/DetailRequest.vue"),
    },
    // ADIRA VIRTUAL EXPO
    {
      path: "/adiravirtualexpo/simulasi-cicilan",
      name: "adira_virtual_expo",
      meta: {
        layout: "event",
        guest: true,
      },
      component: () => import("./views/events/Simulation.vue"),
    },
    {
      path: "/program/:parameter",
      name: "validation_program",
      redirect: "/promo-not-found",
    },
    {
      path: "/program/order/:refferal?",
      name: "program order",
      meta: {
        layout: "new",
        guest: true,
      },
      component: () => import("./views/events/ProductConfirmFillingPromo.vue"),
    },
    {
      path: "/replika/order",
      name: "pengajuan_order",
      component: () => import("./views/product/ProductConfirmFilling.vue"),
    },
    {
      path: "/adiravirtualexpo/register",
      name: "adira_virtual_expo_register",
      meta: {
        layout: "auth",
        guest: true,
      },
      component: () => import("./views/axi/RegisterMobile.vue"),
    },
    // Maintenance
    {
      path: "/maintenance",
      name: "maintenance",
      meta: {
        layout: "event",
        // auth: true
      },
      component: () => import("./views/Maintenance.vue"),
    },
    // Promo Not Found
    {
      path: "/promo-not-found",
      name: "Promo Not Found",
      meta: {
        layout: "event",
        // auth: true
      },
      component: () => import("./views/PromoNotFound.vue"),
    },
    // Promo Expired
    {
      path: "/promo-expired",
      name: "Promo Expired",
      meta: {
        layout: "event",
        // auth: true
      },
      component: () => import("./views/PromoExpired.vue"),
    },
    // AKULAKU
    {
      path: "/order",
      name: "order channel",
      meta: {
        layout: "event",
        // auth: true
      },
      component: () => import("./views/events/ProductConfirmFilling.vue"),
    },
    // PROMO LEBARAN
    {
      path: "/program/info/:refferal?",
      name: `info program`,
      props: true,
      meta: {
        layout: "new",
        // auth: true
      },
      // beforeEnter: (to, from, next) => {
      //   if (from.params.parameter) { //&& from.name === "program order"
      //     next();
      //   } else {
      //     next({
      //       name: "home"
      //     });
      //   }
      // },
      // component: () => import("./views/events/Program.vue"),
      component: () => import("./views/events/InfoProgramPage.vue"),
      // children: [
      //   {
      //     path: "flashdeal",
      //     name: "info program flashdeal",
      //     props: true,
      //     meta: {
      //       layout: "new"
      //     },
      //     component: () => import("./views/events/ProductLebaranPage.vue")
      //   },
      //   {
      //     path: "bagimuguru",
      //     name: "info program bagimuguru",
      //     props: true,
      //     meta: {
      //       layout: "new"
      //     },
      //     component: () => import("./views/events/BagimuguruPage.vue")
      //   },
      //   {
      //     path: "AdiraVirtualExpo",
      //     name: "info program AdiraVirtualExpo",
      //     props: true,
      //     meta: {
      //       layout: "new"
      //     },
      //     component: () => import("./views/events/InfoProgramPage.vue")
      //   }
      // ]
    },
    // PROMO SIMULASI LEBARAN
    {
      path: "/program/simulasi/:id?",
      name: "simulation program",
      redirect: "/promo-not-found",
    },
    // PROMO LEBARAN ORDER FORM
    {
      path: "/program/order/flash-deal/:id?",
      name: "order program page",
      props: true,
      meta: {
        layout: "event",
        // auth: true
      },
      component: () => import("./views/events/ProductLebaranOrderPage.vue"),
    },
    {
      path: "/program/main-order/danamon",
      name: "danamon_page",
      meta: {
        layout: "new",
        guest: true,
      },
      component: () => import("./views/events/programs/DanamonPage.vue"),
    },
    {
      path: "/program/simple-order/adiraku",
      name: "programOrderAdiraku",
      meta: {
        layout: "new",
        guest: true,
      },
      component: () => import("./views/events/AdirakuSimpleForm.vue"),
    },
    {
      path: "/program/order/thank-you/:id?",
      name: "programOrderThankYou",
      meta: {
        layout: "new",
        guest: true,
      },
      component: () => import("./views/events/ThankYouPage.vue"),
    },
    {
      path: "/forbidden",
      name: "forbidden",
      meta: { layout: "blank" },
      component: () => import("./views/Forbidden.vue"),
    },
    // DIRECT AXI REFERRAL LINK (dicicilaja.com/:axi_id)
    {
      path: "/:axi_id",
      name: "axi_referral_redirect",
      beforeEnter: async (to, from, next) => {
        const axiId = to.params.axi_id;
        if (axiId && axiId.length >= 6) {
          try {
            const result = await store.dispatch("order/checkAxiIdReplika", axiId);
            if (result && result.length > 0) {
              sessionStorage.setItem("axi_id", result[0].attributes.nomor_axi_id);
              store.dispatch("auth/setAxiId", result[0].attributes.profile_id);
              next({ name: "axi_register" });
              return;
            }
          } catch (e) {
            console.error("AXI Referral ID tidak valid:", e);
          }
        }
        next({ name: "not_found" });
      },
    },
    // NOT FOUND PAGE
    {
      path: "*",
      name: "not_found",
      meta: {
        layout: "blank",
      },
      component: () => import("./views/NotFound.vue"),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});
router.beforeEach((to, from, next) => {
  const path = to.path;

  // regex: cocokkan path yang diawali /css, /js, /img, atau /fonts
  const forbiddenRegex = /^\/(css|js|img|fonts)(\/|$)/;

  if (forbiddenRegex.test(path)) {
    next({ name: "forbidden" });
    return;
  }

  if (store.getters["auth/isLoggedIn"]) {
    store.dispatch("auth/checkAuth").catch((error) => {
      if (error.response && error.response.status === 401) {
        store.commit("auth/LOGOUT");
        window.location.reload();
      }
    });
    if (to.name.includes("login")) {
      next({ name: "home" });
      return;
    }
  } else if (
    to.path.includes("produk-pembiayaan") &&
    to.path.includes("confirmation") &&
    !to.path.includes("fromgrab") &&
    !to.path.includes("replika") &&
    !sessionStorage.getItem("simulasi_draft_data")
  ) {
    next({ name: "login", query: { from: to.fullPath } });
    return;
  }
  next();
});

export default router;
